<div class="container">
  <div class="layout-row align-end gap-2px responsive-column m-b-20">
    <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_ACCOUNTINGRULE'">
      <fa-icon icon="edit" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Edit' | translate }}
    </button>
    <button
      mat-raised-button
      color="warn"
      (click)="deleteAccountingRule()"
      *LOSxHasPermission="'DELETE_ACCOUNTINGRULE'"
    >
      <fa-icon icon="trash" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Delete' | translate }}
    </button>
  </div>

  <mat-card>
    <mat-card-content class="content-rows">
      <div class="content-row">
        <div class="label">{{ 'labels.inputs.Office' | translate }}</div>
        <div class="value">{{ accountingRule.officeName }}</div>
      </div>

      @if (accountingRule.description) {
        <div class="content-row">
          <div class="label">{{ 'labels.inputs.Description' | translate }}</div>
          <div class="value">{{ accountingRule.description }}</div>
        </div>
      }

      <div class="content-row">
        <div class="label">{{ 'labels.inputs.Multiple Debit Entries Allowed' | translate }}</div>
        <div class="value">{{ accountingRule.allowMultipleDebitEntries }}</div>
      </div>

      <div class="content-row">
        <div class="label">{{ 'labels.inputs.Multiple Credit Entries Allowed' | translate }}</div>
        <div class="value">{{ accountingRule.allowMultipleCreditEntries }}</div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-content class="content-rows">
      @if (accountingRule.debitTags?.length) {
        <div class="content-row">
          <div class="label">{{ 'labels.inputs.Debit Tags' | translate }}</div>
          <div class="value">
            @for (debitTag of accountingRule.debitTags; track debitTag) {
              <span>{{ debitTag.tag.name }}</span>
            }
          </div>
        </div>
      }

      @if (accountingRule.debitAccounts?.length) {
        <div class="content-row">
          <div class="label">{{ 'labels.inputs.Debit Account Name' | translate }}</div>
          <div class="value">
            @for (debitAccount of accountingRule.debitAccounts; track debitAccount) {
              <span>{{ debitAccount.name + ' (' + debitAccount.glCode + ')' }}</span>
            }
          </div>
        </div>
      }

      @if (accountingRule.creditTags?.length) {
        <div class="content-row">
          <div class="label">{{ 'labels.inputs.Credit Tags' | translate }}</div>
          <div class="value">
            @for (creditTag of accountingRule.creditTags; track creditTag) {
              <span>{{ creditTag.tag.name }}</span>
            }
          </div>
        </div>
      }

      @if (accountingRule.creditAccounts?.length) {
        <div class="content-row">
          <div class="label">{{ 'labels.inputs.Credit Account Name' | translate }}</div>
          <div class="value">
            @for (creditAccount of accountingRule.creditAccounts; track creditAccount) {
              <span>{{ creditAccount.name + ' (' + creditAccount.glCode + ')' }}</span>
            }
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
